<div class="modal-header">{{header}}</div>
<div class="modal-body">
	<form id="report-profile" bfmForm [formGroup]="profileForm" [bentoBusyLoader]="isLoaderBusy"
		(ngSubmit)="profileSubmit()" novalidate [validations]="validations">
		<div class="row">
			<div class="col-md-5">
				<div class="form-group">
					<label class="bento-label-required" [ngClass]="{'text-danger': isControlInValid('name') }"
						for="profileName">
						<span translate="onvio.reporting.FirmManagementReportProfile.profile.profileName"></span>
					</label>
					<div class="form-inline">
						<input bfmField bfmLabel="Profile name" formControlName="name" id="profileName"
							(change)="validateUniqueness()" [validations]="validations.name"
							[ngClass]="{'col-sm-12': !profileNameCheckLoader , 'col-sm-11': profileNameCheckLoader}"
							type="text" class="form-control">
						<span class="pb-5" [bentoBusyLoader]="profileNameCheckLoader" [size]="'sm'"></span>
					</div>
				</div>
				<div class="form-group">
					<label class="bento-label" [ngClass]="{'text-danger': isControlInValid('profileType') }"
						for="profileType">
						<span translate="onvio.reporting.FirmManagementReportProfile.profile.profileType"></span>
					</label>
					<select bfmField bfmLabel="Type" formControlName="profileType" id="profileType"
						(change)="firmTypeChange()" class="form-control">
						<option [value]="type" *ngFor="let type of profileTypes">{{type}}
						</option>
					</select>
				</div>
			</div>
		</div>
		<!-- Report & custom name labels-->
		<div class="row">
			<div class="col-md-5">
				<label class="bento-label-required" [ngClass]="{'text-danger': isReportValid }" for="profileName">
					<span translate="onvio.reporting.FirmManagementReportProfile.profile.Report"></span>
				</label>
			</div>
			<div class="col-md-5">
				<label class="bento-label-required" [ngClass]="{'text-danger': isCustomNameValid }" for="profileName">
					<span translate="onvio.reporting.FirmManagementReportProfile.profile.CustomName"></span>
				</label>
			</div>
		</div>
		<!-- Report Profile Selection -->
		<ng-container formArrayName="reportProfileSelections">
			<div class="report-selection">
				<ng-container *ngFor="let customGroup of reportsFA.controls; let i=index">
					<div class="row" [formGroupName]="i">
						<div class="col-md-5 form-group">
							<ng-container formGroupName="reportDefinition">
								<select bfmField bfmLabel="Report" formControlName="id" id="selectionId"
									(change)="onChange(i,$event.target.value)" class="form-control">
									<option disabled value=""><span translate="onvio.reporting.FirmManagementReportProfile.profile.reportSelectionOption"></span></option>
									<ng-container *ngIf="reports">
										<option [value]="report.id" *ngFor="let report of reports">{{report.name}}
										</option>
									</ng-container>
								</select>
							</ng-container>
						</div>
						<div class="col-md-5 form-group">
							<input bfmField bfmLabel="Custom Name" formControlName="name" id="name"
								(change)="checkCustomNameExist(i)"
								[validations]="validations.reportProfileSelectionName" type="text" class="form-control">
						</div>
						<div class="col-md pl-0" *ngIf="i > 0">
							<div class="form-group">
								<a id="{{'Rmv'+i}}" (click)="deleteReport(i)"> <i
										class="bento-icon-close-thick"></i><span translate="onvio.reporting.FirmManagementReportProfile.profile.reportSelectionOption.remove"></span></a>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</ng-container>
		<!-- Add another report -->
		<div class="form-group">
			<a id="addreport" (click)="addReport()"> <i class="bento-icon-add"></i><span translate="onvio.reporting.FirmManagementReportProfile.profile.reportSelectionOption.addReport"></span></a>
		</div>
		<!-- Cancel & Save buttons -->
		<div class="form-group">
			<input class="btn btn-primary mr-3" id="saveBtn" type="submit" value="Save" [disabled]="!isSubmitAllowed">
			<input class="btn btn-default" id="cancelBtn" type="button" value="Cancel" (click)="cancel()">
		</div>
	</form>
	<!-- Alert Message -->
</div>

<div class="row d-flex justify-content-center">
	<bento-alert [inline]="true" [items]="alerts">
	</bento-alert>
</div>
